"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SectionDivider = void 0;
var react_1 = __importDefault(require("react"));
var draft_divider_1 = require("@kaizen/draft-divider");
var SectionDivider_module_scss_1 = __importDefault(require("./SectionDivider.module.scss"));
var SectionDivider = function () { return (react_1["default"].createElement("li", { className: SectionDivider_module_scss_1["default"].divider, "aria-hidden": "true" },
    react_1["default"].createElement(draft_divider_1.Divider, { variant: "canvas" }))); };
exports.SectionDivider = SectionDivider;
//# sourceMappingURL=SectionDivider.js.map